import { ActionTypes } from "../constants/action-types";

const initialState = {
  sponsors: [],
  totalsponsors: 0,
};

export const FetchSponsors = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SPONSORS_SUCCESS:
      return {
        ...state,
        sponsors: action.payload,
        totalsponsors: action.payload.length,
      };

    default:
      return state;
  }
};

export default FetchSponsors;
